import { IToasterServiceStrategy } from 'affiny-core/services/toaster/toaster';
import { WebRoutes } from 'affiny-web/src/routes';
import i18n from 'i18next';
import React, { ReactText } from 'react';
import { toast, ToastContainer, ToastOptions } from 'react-toastify';
import styled from 'styled-components';
import { RoutesNames } from '../routes/routes-names';

const toastOptions: ToastOptions = {
  autoClose: 5000,
  closeOnClick: true,
};

export class ToasterDesktopStrategy implements IToasterServiceStrategy {
  private toastId: ReactText | null = null;

  public show = (key: string, options?: object) => {
    if (
      !this.toastId &&
      (window.location.pathname.indexOf(
        WebRoutes.ProfileCaptureProfilePicture
      ) !== -1 ||
        window.location.pathname.indexOf(RoutesNames.MyProfile) !== -1)
    ) {
      const content = (
        <SToastContent data-test={`toaster-${key}`}>
          {i18n.t(key, options)}
        </SToastContent>
      );

      this.toastId = toast.warn(content, {
        ...toastOptions,
        onClose: this.hide,
      });
    }
  };

  public hide = () => {
    if (this.toastId) {
      toast.dismiss(this.toastId);
      this.toastId = null;
    }
  };
}

const SToastContent = styled.div`
  text-align: center;
`;

export const SToastContainer = styled(ToastContainer)`
  .Toastify__toast {
    background-color: ${({ theme }) => theme.colors.chivalrous};
    color: ${({ theme }) => theme.colors.light};
  }
`;
